export class SearchQueryModel {
    searchQuery?: any;
    isEmpty: boolean;
    table?: string;
  }

  export interface EntityInputModel {
    keyword: string;
    type: string;
    status: string;
    phone: string;
    email: string;
    updated_date_from: string;
    updated_date_to: string;
    search_word: string;
    txn_type: string;
    hdr_updated_date_from: string;
    hdr_updated_date_to: string;
    categories : string;
    default_sales_agents: any;
    default_label_guids: any;
  }

export class SearchQueryContainerModel {
  keyword?: string;
  created_date_from?: string;
  created_date_to?: string;
  updated_date_from?: string;
  updated_date_to?: string;
  status?: string;
}
